import React from "react"
import Products from "../../components/products/Products";
import Layout from "../../components/layout/Layout";
import Hero from "../../components/layout/page/Hero";
import PageSection from "../../components/layout/page/PageSection";
import { useOktaAuth } from '@okta/okta-react';

const ProductList = () => {
  const { authState } = useOktaAuth();

  let showAuthMsg = true;
  if (authState !== null && authState.isAuthenticated) {
    showAuthMsg = false;
  }

  return (
    <Layout>
      <Hero title="Downloads" class="software-downloads-postgres" showAuth={showAuthMsg} />
      <PageSection>
        <Products />
      </PageSection>
    </Layout>
  )
}

export default ProductList